import { useState, useCallback, useRef } from 'react'
import { api } from '@api/client'

export function useFeedback(me) {
  const [feedbackOpen, setFeedbackOpen] = useState(false)
  const contextRef = useRef(null)

  const openFeedbackModal = useCallback(() => {
    contextRef.current = {
      userName: me?.name || '',
      userEmail: me?.email || '',
      userRole: me?.isSuperAdmin ? 'super-admin' : (me?.isAdmin ? 'admin' : ''),
      userId: me?.userId || '',
      currentPage: window.location.pathname,
      meetingId: null,
      userAgent: navigator.userAgent,
      submittedAt: new Date().toISOString(),
    }
    setFeedbackOpen(true)
  }, [me])

  const closeFeedbackModal = useCallback(() => {
    setFeedbackOpen(false)
  }, [])

  const submitFeedback = useCallback(async (type, subject, description) => {
    return api.submitFeedback({
      type,
      subject,
      description,
      context: contextRef.current,
    })
  }, [])

  return {
    feedbackOpen,
    openFeedbackModal,
    closeFeedbackModal,
    submitFeedback,
  }
}
